"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlaySlideInfo = exports.SlideInfo = exports.SlideDescription = exports.SlideHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_copyright_1 = require("@hotelplan/core.basis.bs-copyright");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.SlideHeader = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    margin: 0,
    pl: 0,
    pr: '30px',
    mb: ['15px', null],
    color: '#adabab',
    position: 'fixed',
    top: [3, 4],
    left: [4, 'calc(15% / 2)'],
    zIndex: 2,
    fontSize: '14px',
}));
exports.SlideDescription = styled_components_1.default.div(({ isHideBackground }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    color: 'white',
    pt: [2, 3],
    pb: 3,
    pl: [3, '40px'],
    pr: [3, '65px'],
    fontSize: 0,
    pointerEvents: 'none',
    ':before': {
        content: isHideBackground ? '' : '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'linear-gradient(-180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.4) 100%)',
    },
    '.slide-number': {
        zIndex: 1,
        flex: '0 0 auto',
        pb: '10px',
    },
    '.slide-title': {
        zIndex: 1,
    },
}));
function SlideInfo(props) {
    const { item, slide, count, isHideNavigation = false } = props;
    if (!item) {
        return null;
    }
    return (react_1.default.createElement(exports.SlideDescription, { className: `slide-info`, isHideBackground: isHideNavigation && item.__typename === 'VideoMediaItem' },
        slide && count && !isHideNavigation ? (react_1.default.createElement("div", { className: `slide-number` },
            slide,
            " | ",
            count)) : null,
        item.title && react_1.default.createElement("span", { className: "slide-title" }, item.title)));
}
exports.SlideInfo = SlideInfo;
function OverlaySlideInfo(props) {
    var _a;
    const { item, slide, count, copyrightLabel, isHideNavigation = false, } = props;
    if (!item || item.__typename !== 'ImageMediaItem') {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        slide && count && !isHideNavigation ? (react_1.default.createElement(exports.SlideHeader, null,
            slide,
            " | ",
            count)) : null,
        react_1.default.createElement("div", { className: "slide-info" },
            ((_a = item.preview) === null || _a === void 0 ? void 0 : _a.copyright) && (react_1.default.createElement(core_basis_bs_copyright_1.BsCopyright, null,
                copyrightLabel,
                " ",
                item.preview.copyright)),
            item.title && react_1.default.createElement("span", { className: "slide-title" }, item.title),
            item.image.description && (react_1.default.createElement("p", { className: "slide-description" }, item.image.description)))));
}
exports.OverlaySlideInfo = OverlaySlideInfo;
//# sourceMappingURL=slide-info.js.map